import React from 'react';
import { Route } from 'react-router-dom';
import PaymentTerms from './PaymentTerms/PaymentTerms';
import Quote from './Quote/Quote';

const Routes = function Routes(): React.ReactElement {
  return (
    <>
      <Route path='/quote/:quoteId/payment' exact>
        <PaymentTerms />
      </Route>
      <Route path='/quote/:quoteId' exact>
        <Quote />
      </Route>
    </>
  );
};

export default Routes;
